"use client";

import React from "react";
import { Star, MapPin, ShieldCheck } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const reviews = [{
  id: 1,
  name: "Jean-Pierre M.",
  location: "Paris, France",
  text: "Jim Yang organized an incredible 10-day journey through the Miao villages. The authenticity of the ethnic experiences was beyond our expectations. Truly the best way to see Guizhou.",
  date: "2 weeks ago"
}, {
  id: 2,
  name: "Sophia K.",
  location: "Berlin, Germany",
  text: "The karst landscapes are breathtaking. Our guide was knowledgeable and the private transport was very comfortable. Guizhou Voyage made everything seamless and professional.",
  date: "1 month ago"
}, {
  id: 3,
  name: "Marco R.",
  location: "Rome, Italy",
  text: "Excellent service from start to finish. The tiered pricing for our group of four was very fair, and the local food recommendations were a highlight of our trip to China.",
  date: "3 months ago"
}, {
  id: 4,
  name: "Yuki T.",
  location: "Tokyo, Japan",
  text: "A very deep cultural immersion. We loved the traditional paper-making workshop and the stunning waterfalls. Jim's attention to detail is remarkable. Highly recommended!",
  date: "1 week ago"
}, {
  id: 5,
  name: "Elena S.",
  location: "Madrid, Spain",
  text: "The most authentic travel experience I've had in Asia. No tourist traps, just real culture and beautiful nature. The TripAdvisor reviews were right—this agency is top-tier.",
  date: "2 months ago"
}];
function WhatYourNeighborsSay() {
  return <section data-section-id="235126" id="voices-of-travelers" className="relative bg-background py-24 overflow-hidden">
      <div className="absolute inset-0 pointer-events-none opacity-[0.05] dark:opacity-[0.08]">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1623046/img/guizhou_topography_pattern.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1623046/img/guizhou_topography_pattern.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1623046/img/guizhou_topography_pattern.png-wvc-sizes" alt="" loading="lazy" className="absolute inset-0 w-full h-full object-cover mix-blend-multiply" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6">
          <div className="max-w-2xl">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold text-foreground tracking-tight mb-4">
              Voices of Travelers
            </h2>
            <p className="text-lg text-muted-foreground font-default">
              Discover why explorers from around the world choose Guizhou Voyage for their authentic ethnic and nature experiences in Southwest China.
            </p>
          </div>
        </div>

        <Carousel opts={{
        align: "start",
        loop: true,
        duration: 25
      }} className="w-full">
          <CarouselContent className="-ml-4 md:-ml-6 transition-transform duration-200">
            {reviews.map((review, i) => <CarouselItem key={review.id} data-index={i} className="pl-4 md:pl-6 md:basis-1/2 lg:basis-1/3">
                <Card className="h-full flex flex-col bg-card border-border/60 shadow-sm rounded-xl">
                  <CardHeader className="pb-4">
                    <div className="flex items-center justify-between mb-2">
                      <div className="flex gap-1">
                        {[...Array(5)].map((_, starIndex) => <Star key={starIndex} className="size-5 fill-chart-3 text-chart-3" />)}
                      </div>
                      <span className="text-xs text-muted-foreground font-mono">
                        {review.date}
                      </span>
                    </div>
                  </CardHeader>
                  <CardContent className="flex-grow pb-6">
                    <p className="text-foreground font-default leading-relaxed italic">
                      "{review.text}"
                    </p>
                  </CardContent>
                  <CardFooter className="pt-0 flex flex-col items-start gap-4 border-t border-border/30 mt-auto pt-6">
                    <div className="flex items-center justify-between w-full">
                      <div>
                        <p className="font-default font-semibold text-foreground text-lg">
                          {review.name}
                        </p>
                        <div className="flex items-center text-muted-foreground mt-1">
                          <MapPin className="size-3.5 mr-1.5 text-secondary" />
                          <span className="text-sm font-default">
                            {review.location}
                          </span>
                        </div>
                      </div>
                      <Badge variant="secondary" className="bg-primary/10 text-primary border-primary/20 rounded-full">
                        <ShieldCheck className="size-3 mr-1" />
                        Verified Traveler
                      </Badge>
                    </div>
                  </CardFooter>
                </Card>
              </CarouselItem>)}
          </CarouselContent>
          <div className="flex justify-end gap-2 mt-8 md:hidden">
            <CarouselPrevious className="relative inset-auto size-10 translate-y-0 translate-x-0 bg-background border-border hover:bg-accent hover:text-accent-foreground rounded-full" />
            <CarouselNext className="relative inset-auto size-10 translate-y-0 translate-x-0 bg-background border-border hover:bg-accent hover:text-accent-foreground rounded-full" />
          </div>
          <div className="hidden md:block">
            <CarouselPrevious className="-left-12 bg-background border-border hover:bg-accent hover:text-accent-foreground shadow-sm rounded-full" />
            <CarouselNext className="-right-12 bg-background border-border hover:bg-accent hover:text-accent-foreground shadow-sm rounded-full" />
          </div>
        </Carousel>
      </div>
    </section>;
}
export default React.memo(WhatYourNeighborsSay);